export enum LostDeviceStep {
  RecoveryMethod = 'recoveryMethod',
  RecoveryCode = 'recoveryCode',
  MissingCode = 'missingCode',
  SuccessAdminNotified = 'successAdminNotified',
}
